import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Menu, Card, InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import { TabPanel } from "@mui/lab";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import uploadLogoImgage from "../../../assets/images/UploadLogo.png";
import {
  getCountry,
  getCountryList,
  getMobileOTP,
  updateUserProfile,
  verifyUserMobileOTP,
  getTimeZoneList
} from "../service";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MapplsAutocomplete from "../../../components/MapplsAutocomplete/MapplsAutocomplete";
import "./PersonalTab.css";
import { setUserDetails } from "../../Login/slice/userSlice";
import { notifyError, notifySuccess } from "../../../components/ToastNotification/ToastNotification";


const PersonalTab = ({
  userProfile,
  setUserProfile,
  value,
  setValue,
  getUserProfile,
  mobielNo,
  mobileCountryCode,
  setMobileNo,
  setMobileCountryCode,
}) => {
  const [selecteCountry, setSelecteCountry] = useState("India");
  const [selectUserCountryCode, setUserCountryCode] = useState("");
  const [countryData, setCountryData] = useState([]);
  const { id } = useSelector((state) => state.userState);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState("");
  const [countryCode, setCountryCode] = useState("91");
  const [uploadLogo, setUploadLogo] = useState("");
  const [OTPMobile, setOTPMobile] = useState("");
  const [greenIcone, setGreenIcone] = useState(false);
  const [address, setAddress] = useState("");
  const [siteAddress, setSiteAddress] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(60);
  const [visibleOTP, setvisibleOTP] = useState(false);
  const [mobileCountryCode1, setMobileCountryCode1] = useState("+1"); // Default value, change as needed
  const [selectUserCountry, setSelectUserCountry] = useState("");
  const { user_access } = useSelector((state) => state.userState);


  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  const { mobileNoRe } = useSelector((state) => state.userState);

  const selecteCountryCode = countryData.length
    ? countryData.find((f) => f.id == selecteCountry)
    : "";

  const handleChangeCountryCode1 = (event) => {
    const selectedCode = event.target.value;
    setMobileCountryCode(selectedCode);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedItem(index);
    setAnchorEl(null);
    setCountryCode(event.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // find Place
  const handleSelect = (value, suggestion) => {
    setAddress(value);
    if (suggestion && suggestion.placeAddress) {
      setSiteAddress(suggestion.placeAddress);
    } else {
      setSiteAddress(value);
    }
  };

  const handleChangeSelectCountry = (event) => {
    let selectedCountryCode = event.target.value;
    let selectedCountry = event.target.id;

    const selectedCountry1 = countryData?.find(
      (country) => country.country === selectedCountryCode
    );
    if (selectedCountry1) {
      setUserCountryCode(selectedCountry1.id);
      setMobileCountryCode(selectedCountry1.country_code)
      setSelecteCountry(selectedCountry1.country);
    }
  };

  const getCountryListAPI = async () => {
    try {
      const resp = await getCountryList();
      if (resp.status === 200) {
        setCountryData(resp.data.payload);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTimeZoneListAPI = async () => {
    try {
      // const response = await getTimeZoneList();
      // if (response.status === 200 || response.status === 201) {
      //   setTimeZones(response.data.payload);
      // }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }
  const dispatch = useDispatch()

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    getCountryListAPI();
    getTimeZoneListAPI();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    setAddress(userProfile.company_name);
    setSiteAddress(
      userProfile.site_address == "null" ? "" : userProfile.site_address
    );
    setSelecteCountry(userProfile.user_country_name);
    setUserCountryCode(userProfile.user_country);
  }, [userProfile.company_name, userProfile.site_address, value,]);

  useEffect(() => {
    const firstThreeDigits = Math.floor(
      userProfile.mobile_number /
      Math.pow(10, Math.floor(Math.log10(userProfile.mobile_number)) - 1)
    );
    setCountryCode(firstThreeDigits);
  }, []);

  const handlePersonalDataForm = (e) => {
    setUserProfile({ ...userProfile, [e.target.name]: e.target.value });
  };

  const handleChangeMobile = (e) => {
    setMobileNo(e.target.value);
  };

  const handleChangeCountryCode = (e) => {
    setMobileCountryCode(e.target.value);
  };

  const handleLogoUpload = (event) => {
    const logoFile = event.target.files[0];
    if (logoFile) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

      if (!validImageTypes.includes(logoFile.type)) {
        notifyError('Please upload a valid image file (jpeg, png, jpg)');
        event.target.value = ""; // Reset the file input
        return;
      }
      setUserProfile({ ...userProfile, company_logo: logoFile.name });
      setUploadLogo(logoFile);
    }
  };

  function validateMobileNumber(mobileNumber) {
    // Regular expression pattern for a valid 10-digit mobile number
    var pattern = /^[1-9]{1}[0-9]{9}$/;

    // Test the input mobile number against the pattern
    return pattern.test(mobileNumber);
  }

  const updateSubmit = async () => {
    const formData = new FormData();
    formData.append("first_name", userProfile.first_name);
    formData.append("last_name", userProfile.last_name);
    formData.append("company_name", address);
    formData.append("site_address", siteAddress);
    formData.append("user_role_name", userProfile.user_role_name);
    formData.append("two_step_verification", userProfile.two_step_verification);
    formData.append("mfa", userProfile.mfa);
    formData.append("communication_email", userProfile.communication_email);
    formData.append(
      "communication_phone_call",
      userProfile.communication_phone_call
    );

    if (!mobielNo) {
      notifyError("Please Verify Mobile No");
      return true;
    }

    if (!validateMobileNumber(mobielNo)) {
      notifyError("Invalid mobile number.");
      return true;
    }

    if (mobielNo) {
      formData.append(
        "mobile_number",
        Number(`${mobielNo}`)
      );
    }

    if (uploadLogo && userProfile.company_name) {
      formData.append("company_logo", uploadLogo);
    }

    if (selectUserCountryCode) {
      formData.append("user_country", selectUserCountryCode);
    }

    try {
      const resp = await updateUserProfile(id, formData);
      if (resp) {
        notifySuccess("Updated Successfully");
        getUserProfile();
        setValue("2");
      }
    } catch (error) {
      notifyError(error.response.data.message);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    const formattedDate = `${date.toLocaleTimeString("en-US", options)} IST`;
    return formattedDate;
  };

  const dateStr = userProfile.last_login;
  const formattedDate = dateStr ? formatDate(dateStr) : "-";

  return (
    <>
      <TabPanel value="1">
        <Typography variant="subtitle1">Last login {formattedDate}</Typography>
        <Grid container spacing={8}>
          <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
            <Typography
              variant="subtitle1"
              gutterBottom
              pt="20px"
              style={{ fontWeight: 600, color: "#001323" }}
            >
              {" "}
              Your Personal Details
            </Typography>
            <Stack spacing={2} pt="10px">
              <TextField
                id="filled-basic"
                name="first_name"
                label="First Name"
                variant="filled"
                className="customeTextField personal"
                value={userProfile?.first_name}
                onChange={handlePersonalDataForm}
                InputLabelProps={{
                  shrink: Boolean(userProfile?.first_name),
                }}
              />
              <TextField
                id="filled-basic"
                name="last_name"
                label="Last Name"
                variant="filled"
                className="customeTextField personal"
                value={userProfile?.last_name}
                onChange={handlePersonalDataForm}
                InputLabelProps={{
                  shrink: Boolean(userProfile?.last_name),
                }}
              />
              <TextField
                id="filled-basic"
                label="Email"
                variant="filled"
                className="customeTextField personal"
                value={userProfile?.email}
                disabled
                InputLabelProps={{
                  shrink: Boolean(userProfile?.email),
                }}
              />
              <TextField
                id="phone-number"
                label="Mobile No"
                variant="filled"
                value={mobielNo}
                onChange={handleChangeMobile}
                InputLabelProps={{
                  style: { marginBottom: "10px" },
                }}
                InputProps={{
                  inputProps: { maxLength: 10 },
                  startAdornment: (
                    <div className="profile-dropdown-container">
                      <select
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          marginRight: "0px",
                          paddingTop: "0px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        className="PersonalTabn-dropdown"
                        value={selecteCountry ? selecteCountry : "India"}
                        onChange={handleChangeSelectCountry}
                      >
                        {countryData?.length
                          ? countryData.map((row) => {
                            return (
                              <option
                                id={row.country_code_name}
                                value={row.country}
                                style={{ paddingTop: "20px" }}
                              >
                                {row.country_code}
                              </option>
                            );
                          })
                          : []}
                      </select>
                    </div>
                  )
                }}
              />
            </Stack>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
            <Typography
              variant="subtitle1"
              className="userProfile-companyDetails"
              style={{ fontWeight: 600, color: "#001323" }}
            >
              Your Company Details
            </Typography>
            <Stack spacing={2} pt="15px">
              <FormControl
                variant="filled"
                sx={{ minWidth: 120 }}
                className="customeTextField personal"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Country
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={selecteCountry}
                  onChange={handleChangeSelectCountry}
                >
                  {countryData?.map((e) => (
                    <MenuItem id={e.id} value={e.country} name={e.country_code}>
                      {e.country}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <MapplsAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelect}
                label="Company"
                variant="filled"
                className="customeTextField personal"
                countryCode={selecteCountryCode?.country_code_name || ""}
              />
          
              <TextField
                id="filled-basic"
                name="site_address"
                label="Site Address"
                variant="filled"
                style={{ width: "100%" }}
                className="customeTextField personal"
                value={siteAddress}
                onChange={handlePersonalDataForm}
                InputLabelProps={{
                  shrink: Boolean(siteAddress),
                }}
              />

              <TextField
                id="filled-basic"
                label="Company Logo"
                variant="filled"
                className="customeTextField personal"
                value={
                  userProfile
                    ? userProfile.company_logo
                      ? userProfile.company_logo.split("/").pop()
                      : ""
                    : ""
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <label htmlFor="logo-upload">
                        <img
                          src={uploadLogoImgage}
                          alt="Upload logo"
                          style={{ cursor: "pointer" }}
                        />
                      </label>
                      <input
                        id="logo-upload"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleLogoUpload}
                      />
                    </InputAdornment>
                  ),
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: Boolean(userProfile ? userProfile.company_logo : ""),
                }}
              />
              <Typography
                variant="caption"
                display="block"
                gutterBottom
                className="mt-1"
              >
                <b>Note:</b> not more than 2MB, 200x40 Aspect ratio
              </Typography>
              <TextField
                id="filled-basic"
                name="user_role_name"
                label="User Role"
                variant="filled"
                className="customeTextField personal"
                value={
                  userProfile
                    ? userProfile.user_role_name == "null"
                      ? ""
                      : userProfile.user_role_name
                    : ""
                }
                disabled
                InputLabelProps={{
                  shrink: Boolean(userProfile?.user_role_name),
                }}
              />
            </Stack>
          </Grid>
          <Box className="profileButton-wrap personalTab">
            <button
              className="cancelButton"
              onClick={() => {
                // if (!mobileNoRe) {
                //   notifyError("Please Verify Mobile No");
                //   return true;
                // }
                navigate(-1);
              }}
            >
              Cancel
            </button>
            <button
              className="updateButton"
              style={{ marginLeft: "10px" }}
              onClick={() => updateSubmit()}
            >
              Update
            </button>
          </Box>
        </Grid>
      </TabPanel>
    </>
  );
};

export default PersonalTab;
